import BackgroundVideo from '@maison/components/molecules/BackgroundVideo.vue';
import createVueApp from '@phoenix/createVueApp';

document.querySelectorAll('.phoenix-background-video').forEach((el) => {
  const app = createVueApp({}, false);
  app.component('BackgroundVideo', BackgroundVideo);
  app.mount(el);
});
